<template>
  <footer
    id="contact"
    class="flex flex-col justify-between text-center w-full bg-white text-black text-[20px] min-h-screen relative z-30"
  >
    <!-- Top trapezoid -->
    <div
      class="absolute -top-[60px] left-0 w-full h-[60px] pointer-events-none"
      style="clip-path: polygon(0 0, 100% 100%, 0 100%)"
    >
      <div class="w-full h-full bg-white"></div>
    </div>

    <!-- Main content -->
    <div class="flex-1 flex items-center justify-center">
      <div class="max-w-[850px] relative px-5">
        <CornerDecoration color="black" offset="-25px" />

        <div>
          <p>Headquartered in Amsterdam.</p>
          <p>Operating globally.</p>
        </div>

        <div class="mt-16 space-y-1">
          <p>Postjesweg 1, 1057 DT, Amsterdam NL</p>
        </div>

        <div class="text-gray-500 mt-8">
          <a href="mailto:hq@deepcuts.nl" class="hover:text-black transition-colors">Email</a>,
          <a
            href="https://open.spotify.com/user/31q5g4dpz2gfmuzgqgt422mwzvb4?si=ce16225823144103"
            target="_blank"
            rel="noopener"
            class="hover:text-black transition-colors"
            >Spotify</a
          >,
          <a
            href="https://instagram.com/deepcutsams"
            target="_blank"
            rel="noopener"
            class="hover:text-black transition-colors"
            >Instagram</a
          >
        </div>
      </div>
    </div>

    <!-- Logo and legal -->
    <div class="w-full flex flex-col justify-center relative px-4 mt-auto">
      <!-- Desktop -->
      <div class="hidden md:block">
        <img src="/footer-logo.svg" alt="DeepCuts" class="w-full" />
        <div class="relative w-full bottom-[20px]">
          <div
            class="w-full flex justify-between text-[9px] text-[#808080] mono tracking-[0.01em] leading-[24px]"
          >
            <div class="space-x-2">
              <a href="#" class="hover:text-black transition-colors">PRIVACY</a>
              <a href="#" class="hover:text-black transition-colors">COOKIES</a>
              <span>CHAMBER OF COMMERCE 95862021</span>
              <span>VAT NL867351457B01</span>
            </div>
            <div>©2024 DEEP CUTS, ALL RIGHTS RESERVED.</div>
          </div>
        </div>
      </div>

      <!-- Mobile -->
      <div
        class="block md:hidden text-[10px] text-[#808080] mono tracking-[0.01em] leading-[24px] text-center mb-8"
      >
        ©2024 DEEP CUTS. ALL RIGHTS RESERVED. PRIVACY, COOKIES,
        <br />
        CHAMBER OF COMMERCE 95862021, NL867351457B01
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import CornerDecoration from '../components/CornerDecoration.vue'
</script>
